import React from 'react';
import { observer } from 'mobx-react-lite';
import { Route, RouteProps, Redirect } from 'react-router-dom';

import { useStore } from '@src/models';
import { ROUTES } from 'src/constants';

export type PrivateRouteProps = RouteProps & { component: React.ReactNode };
export const PrivateRoute = observer(({ component: Component, ...rest }: PrivateRouteProps) => {
  const {
    authStore: { isAuthorized, isFetching }
  } = useStore();

  if (isFetching) {
    return null;
  }

  return (
    <Route
      render={props => {
        // hack for webpack reload in dev mode
        return isAuthorized || isHackEnabled ? <Component {...props} /> : <Redirect to={ROUTES.defaultPublicRoute} />;
      }}
      {...rest}
    />
  );
});

const isHackEnabled = process.env.DEV_OPS === 'true';
